import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-valorant-solo-divisions',
  templateUrl: './valorant-divisions.component.html'
})
export class ValorantDivisionsComponent {
  service = 'divisions';
  availableServices = services['valorant'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'valorant',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Rank Boost',
    },
    subtitle: {
      en: 'Get the Rank You Want with Our Valorant Boosting Solutions',
      fr: 'Obtenez le rang que vous voulez avec nos solutions de boost Valorant',
      de: 'Hol dir den Rang, den du willst, mit unseren Valorant Boosting-Lösungen',
      pt: 'Consegue o rank que queres com as nossas soluções de Valorant boost',
      es: 'Consigue el rango que quieres con nuestras soluciones de boost Valorant',
    },
    start: DivisionsService.getValueByRank('Silver III', 'valorant'),
    desired: DivisionsService.getValueByRank('Gold I', 'valorant')
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Rank Elo Boosting?",
        answer: "Valorant Elo Boosting can take the form of Rank Boost, which guarantees that the player will achieve the desired rank."
      },
      {
        question: "What If You Demote Before The Service Is Complete?",
        answer: "We promise to deliver the contracted service. Therefore, if something like that were to occur, we would go beyond it and finish the service as planned."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Agents?",
        answer: "Yes, you can. Click the \"Choose your Agents\" button in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost d\'Elo de Rang?",
        answer: "Le Boosting d\'Elo Valorant peut prendre la forme de Boost de rang, qui garantit que le joueur atteindra le rang désiré."
      },
      {
        question: "Que se passe-t-il en cas de rétrogradation avant la fin du service?",
        answer: "Nous nous engageons à fournir le service prévu par le contrat. Par conséquent, si une telle situation devait se produire, nous irions au-delà et terminerions le service comme prévu."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes agents préférés?",
        answer: "Oui, c\'est possible. Cliquez sur le bouton \"Choisissez vos agents\" dans le menu de personnalisation de la commande pour y parvenir."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }

    ],
    de: [
      {
        question: "Was ist ein Rang-Elo-Boosting?",
        answer: "Valorant-Elo-Boosting kann in Form eines Rang-Boosts erfolgen, der garantiert, dass der Spieler den gewünschten Rang erreicht."
      },
      {
        question: "Was passiert, wenn du degradierst, bevor der Dienst beendet ist?",
        answer: "Wir versprechen, die vertraglich vereinbarte Leistung zu erbringen. Sollte dies der Fall sein, so werden wir über unsere Verpflichtungen hinausgehen und den Dienst planmäßig zu Ende führen."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Kann ich meine bevorzugten Agenten auswählen?",
        answer: "Ja, das kannst du. Klicke auf die Schaltfläche \"Choose your Agents\" im Menü zur Bestellungsanpassung, um dies zu tun."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du willst dich im gleichen Ranglistenmodus anstellen wie der gekaufte Dienst. Ansonsten planst du es im Bestell-Chat mit deinem Booster."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }

    ],
    pt: [
      {
        question: "O Que É Um Rank  Boost?",
        answer: "O MMR Boost de Valorant, também conhecido por Rank Boost, garante que o jogador alcance o rank desejado em serviços Solo ou Duo."
      },
      {
        question: "O Que Acontece Se Eu For Despromovido No Decorrer do Serviço?",
        answer: "Nós comprometemo-nos a concluir o serviço com sucesso. Portanto, se algo assim acontecer, iremos cumprir o serviço conforme planeado."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso, vai até ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso escolher os meus Agents preferidos?",
        answer: "Sim, podes. Clica no botão \"Escolhe os teus Agents\" no menu de personalização do serviço que vês acima."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un Rank Elo Boosting?",
        answer: "Valorant Elo Boosting puede adoptar la forma de Rank Boost, que garantiza que el jugador alcanzará el rango deseado."
      },
      {
        question: "¿Qué pasa si descendeis de categoría antes de que finalice el servicio?",
        answer: "Nos comprometemos a prestar el servicio contratado. Por lo tanto, si ocurriera algo así, iríamos más allá y terminaríamos el servicio según lo previsto."
      },
      {
        question: "¿Puedo jugar con el Booster en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir a mis agentes preferidos?",
        answer: "Sí, puedes hacerlo. Haz clic en el botón \"Elige tus Agentes\" en el menú de personalización del pedido."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Valorant Boosting - Premium Boosting Services by GGBoost",
      fr: "Boosting Valorant - Services de Boosting Premium par GGBoost",
      de: "Valorant Boosting - Premium Boosting Services von GGBoost",
      pt: "Valorant Boosting - Serviços de Boost Premium pela GGBoost",
      es: "Valorant Boosting - Servicios de Boosting Premium de GGBoost",
    },
    metaDescription: {
      en: "Elevate your Valorant ranks with GGBoost. Choose our Top-Tier and Secure boosting services, ensuring Exceptional Performance in every match",
      fr: "Améliorez vos rangs Valorant avec GGBoost. Choisissez nos services de boosting de premier ordre et sécurisés, garantissant des performances exceptionnelles à chaque match",
      de: "Verbessere deine Valorant-Ränge mit GGBoost. Entscheide dich für unseren erstklassigen und sicheren Boosting-Service, der dir in jedem Spiel eine herausragende Leistung garantiert.",
      pt: "Eleve seus rankings no Valorant com a GGBoost. Escolha nossos serviços de boost de primeira linha e seguros, garantindo um desempenho excepcional em cada partida.",
      es: "Eleva tus rangos Valorant con GGBoost. Elige nuestros servicios de boosting seguros y de primer nivel, que garantizan un rendimiento excepcional en cada partido.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}